var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 6 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#475161",
  d: "M1.172 2.828 3.001 0l1.828 2.828H1.172Zm3.657 2L3 7.657 1.172 4.828h3.657Z"
})));
export { SvgSelectIcon as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTM0ZGFkODJjYmU3NGRlYjE1NWY4YmMwNWVjN2Q3Zjcuc3ZnIjs=";